import Axios from "axios";
// Actions
import {ACCEPT_PAP, REJECT_PAP} from "../actions/chatCase/pap";
import {setErrorApiMessage} from "../actions/apiFlag";
import {setRedirection} from "../actions/user";
// Utils
import {getSession} from "../common/session.service";
import {getApiBaseUrl} from "../utils/baseUrl";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const pap = (store) => (next) => (action) => {
    // Action permettant d'update en BDD la nature du Plan d'Aide Personnalisé (PAP) : Accepté ou Refusé par le user
    switch (action.type) {
        case ACCEPT_PAP : {
            const url = `${getApiBaseUrl()}/updateCase/`;
            // Destructuring du state
            const state = store.getState();
            const {chatCase} = state;
            // Récupération de la session
            const sessionObj = getSession();
            const {session} = sessionObj;

            const payload = {
                session,
                "idCase": chatCase.idCase,
                "toUpdate": {
                    "state": "5" // State 5 = Accepté
                }
            };

            Axios.post(url, payload, {withCredentials: true})
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });

            next(action);
            break;
        }
        case REJECT_PAP : {
            const url = `${getApiBaseUrl()}/updateCase/`;
            // Destructuring du state
            const state = store.getState();
            const {chatCase} = state;
            // Récupération de la session
            const sessionObj = getSession();
            const {session} = sessionObj;

            const payload = {
                session,
                "idCase": chatCase.idCase,
                "toUpdate": {
                    "state": "100" // State 100 = Refusé
                }
            };
            Axios.post(url, payload, {withCredentials: true})
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });

            next(action);
            break;
        }
        default:
            next(action);
    }
};

export default pap;